import { ZonedDateTime } from '@internationalized/date';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export type CounterpartyGroupMemberDetail = {
  id: string;
  accountId: string;
  addedById: string;
  addedByName: string | null;
  timestamps: {
    createdAt: ZonedDateTime;
  };
};

export const counterpartyGroupMemberDetailsQueryAtom = createQueryAtomFactory(
  'brokerage.counterpartyGroupMemberDetails',
  (params: { groupId: string }) => ({
    counterpartyGroupMemberDetails: {
      __args: {
        groupId: params.groupId,
      },
      id: true,
      accountId: true,
      addedById: true,
      createdByUser: {
        id: true,
        firstName: true,
        lastName: true,
      },
      timestamps: {
        createdAt: true,
      },
    },
  }),
  {
    select: (data): CounterpartyGroupMemberDetail[] => {
      if (!data?.counterpartyGroupMemberDetails) return [];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return data.counterpartyGroupMemberDetails.map((m: any) => ({
        id: m.id,
        accountId: m.accountId,
        addedById: m.addedById,
        addedByName: m.createdByUser
          ? `${m.createdByUser.firstName} ${m.createdByUser.lastName}`.trim()
          : null,
        timestamps: {
          createdAt: parseZonedDateTime(m.timestamps.createdAt),
        },
      }));
    },
  },
);
